import React, { useContext, useState, useEffect } from "react";
import {
  faCancel,
  faCheckCircle,
  faClose,
  faSpinner,
  // faUserPlus,
  faWifi,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MessageModal from "./MessageModal";
import useSWR, { mutate } from "swr";
import TableTotalNCost from "./TableTotalNCost";
import DashboardContenLeftMenus from "./DashboardContenLeftMenus";
import DashboardContentHeader from "./DashboardContentHeader";
import DashboardContentFooter from "./DashboardContentFooter";
import TopActionMenus from "./TopActionMenus";
import SearchFilter from "./SearchFilter";
import { NavigationContext } from "navigation-react";
import LoaderAnimation from "./LoaderAnimationLarge";
import SecureLS from "secure-ls";
const ls = new SecureLS({ encodingType: "aes" });

function parseDate(dateStr) {
  if (!dateStr) return null;

  // Try parsing as ISO format first (from date inputs)
  const isoDate = new Date(dateStr);
  if (!isNaN(isoDate.getTime())) return isoDate;

  // Try parsing as DD/MM/YYYY format
  const parts = dateStr.split("/");
  if (parts.length === 3) {
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1; // months are 0-based
    const year = parseInt(parts[2], 10);
    const parsedDate = new Date(year, month, day);
    if (!isNaN(parsedDate.getTime())) return parsedDate;
  }

  return null;
}

const CtScanRequestAssignedRegister = () => {
  const { data, stateNavigator } = useContext(NavigationContext);
  const [loading, setLoading] = useState(false);
  const [modalEditRequest, setModalEditRequest] = useState(false);
  const [modalAssignRequest, setModalAssignRequest] = useState(false);
  const [isMessageModalIsNotOk, setIsMessageModalIsNotOk] = useState(false);
  const [modalMessages, setModalMessages] = useState("");
  const perm = ls.get("currentuserrole") || [];
  console.log("permissions::", perm);

  const username = ls.get("username");
  const userpw = ls.get("userpw");
  const usercsrf_token = ls.get("usercsrf_token");

  const fetcher = (url) =>
    fetch(url, {
      credentials: "same-origin",
      mode: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Basic ${btoa(`${username}:${userpw}`)}`,
        "X-CSRF-Token": usercsrf_token,
      },
    }).then((res) => res.json());

  const [searchTerm, setSearchTerm] = useState("");
  // Request Date filters
  const [requestStartDate, setRequestStartDate] = useState("");
  const [requestEndDate, setRequestEndDate] = useState("");

  // Reported Date filters
  const [reportedStartDate, setReportedStartDate] = useState("");
  const [reportedEndDate, setReportedEndDate] = useState("");

  // Status filter
  const [statusFilter, setStatusFilter] = useState("");

  const [isMessageModalVisibleEdit, setIsMessageModalVisibleEdit] =
    useState(false);

  const [isMessageModalError, setIsMessageModalError] = useState(false);

  const [isMessageModalVisibleAssigned, setIsMessageModalVisibleAssigned] =
    useState(false);

  const [ctscanAssignedRadioLogist, setctscanAssignedRadioLogist] = useState(
    data?.ct_scan_assigned_radiologistNID
  );
  const [ctscanIvestigation, setctscanIvestigation] = useState(
    data?.ct_scan_investigation_raw
  );
  const [ctscanClinicalDiag, setctscanClinicalDiag] = useState(
    data?.ct_scan_clinical_diagnosis
  );
  const [ctscanComments, setctscanComments] = useState();
  const [ctscanrequestStatus, setctscanrequestStatus] = useState(
    data?.ct_scan_request_status_NID
  );

  useEffect(() => {
    if (data) {
      setctscanAssignedRadioLogist(data.ct_scan_assigned_radiologistNID || "");
      setctscanIvestigation(data.ct_scan_investigation_raw || "");
      setctscanClinicalDiag(data.ct_scan_clinical_diagnosis || "");
      setctscanComments(data.ct_scan_comments || "");
      setctscanrequestStatus(data.ct_scan_request_status_NID || "");
    }
  }, [data]);

  const {
    data: ctrequestsData,
    error: ctrequestsDataError,
    isLoading: ctrequestsDataLoading,
  } = useSWR(`${process.env.REACT_APP_CT_SCAN_ASSIGNED_REQUEST_URL}`, fetcher);
  console.log("CT SCAN REQUEST DATA", ctrequestsData);

  const filteredData = Array.isArray(ctrequestsData)
    ? ctrequestsData.filter((request) => {
        const matchesSearchTerm =
          request.field_patient_id
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          request.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          request.title_1?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          request.field_investigation_price
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          request.field_payment_amount
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          request.field_payment_amount_1
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          request.field_assigned_radiologist
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase());

        // Status filtering
        const matchesStatus =
          !statusFilter ||
          request.field_ct_scan_request_status?.toLowerCase() ===
            statusFilter.toLowerCase();

        // Request Date filtering
        const requestDate = parseDate(request.created);
        const reqStart = requestStartDate ? new Date(requestStartDate) : null;
        const reqEnd = requestEndDate ? new Date(requestEndDate) : null;

        // Reported Date filtering
        const reportedDate = parseDate(request.created_2);
        const repStart = reportedStartDate ? new Date(reportedStartDate) : null;
        const repEnd = reportedEndDate ? new Date(reportedEndDate) : null;

        // Normalize dates by setting time components
        if (reqStart) reqStart.setHours(0, 0, 0, 0);
        if (reqEnd) reqEnd.setHours(23, 59, 59, 999);
        if (requestDate) requestDate.setHours(12, 0, 0, 0);

        if (repStart) repStart.setHours(0, 0, 0, 0);
        if (repEnd) repEnd.setHours(23, 59, 59, 999);
        if (reportedDate) reportedDate.setHours(12, 0, 0, 0);

        const isInRequestDateRange =
          (!reqStart || (requestDate && requestDate >= reqStart)) &&
          (!reqEnd || (requestDate && requestDate <= reqEnd));

        const isInReportedDateRange =
          (!repStart || (reportedDate && reportedDate >= repStart)) &&
          (!repEnd || (reportedDate && reportedDate <= repEnd));

        return (
          matchesSearchTerm &&
          matchesStatus &&
          isInRequestDateRange &&
          isInReportedDateRange
        );
      })
    : [];

  const {
    data: ctscanAssignedRadioData,
    error: ctscanAssignedRadioError,
    isLoading: ctscanAssignedRadioLoading,
  } = useSWR(
    `${process.env.REACT_APP_ASSIGNED_RADIOLOGIST_API}?_format=json`,
    fetcher
  );

  const {
    data: investigationsData,
    error: investigationsError,
    isLoading: investigationsLoading,
  } = useSWR(
    `${process.env.REACT_APP_INVESTIGATIONS_API}?_format=json`,
    fetcher
  );

  const toggleModalEditRequest = () => {
    setModalEditRequest(!modalEditRequest);
  };

  const toggleModalAssignRequest = () => {
    setModalAssignRequest(!modalAssignRequest);
  };

  const toggleModalError = () => {
    setIsMessageModalError(!isMessageModalError);
  };

  const toggleModalIsNotOk = () => {
    setIsMessageModalIsNotOk(!isMessageModalIsNotOk);
  };

  const handleSubmitEdit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!data?.nid) {
      alert("Error: Missing request ID.");
      setIsMessageModalVisibleEdit(true);
      setLoading(false);
      return;
    }

    try {
      const ctrequestPayload = {
        type: [{ target_id: "ct_scan_request" }],
        field_request_reference_investig: [{ target_id: ctscanIvestigation }],
        field_ct_scan_clinical_diagnosis: [{ value: ctscanClinicalDiag }],
        field_ct_scan_comments: [{ value: ctscanComments }],
      };

      const response = await fetch(`/node/${data?.nid}?_format=json`, {
        method: "PATCH",
        credentials: "same-origin",
        mode: "same-origin",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Basic ${btoa(`${username}:${userpw}`)}`,
          "X-CSRF-Token": usercsrf_token,
        },
        body: JSON.stringify(ctrequestPayload),
      });

      if (!response.ok) {
        const error = await response.json();
        console.log(`Error: ${error.message}`);
        setModalMessages(`This request is complete. Editing is not allowed.`);
        setIsMessageModalIsNotOk(true);
        setLoading(false);
        return;
      }

      setctscanAssignedRadioLogist("");
      setctscanIvestigation("");
      setctscanClinicalDiag("");
      setctscanComments("");
      setctscanrequestStatus("");
      setIsMessageModalVisibleEdit(true);
      await Promise.all([
        mutate(`${process.env.REACT_APP_CT_SCAN_REQUEST_URL}`),
        mutate(`${process.env.REACT_APP_CT_SCAN_REPORT_URL}`),
        mutate(`${process.env.REACT_APP_CT_SCAN_ASSIGNED_REQUEST_URL}`),
      ]);
    } catch (error) {
      setIsMessageModalVisibleEdit(false);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitAssigned = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!data?.nid) {
      console("Error: Missing request ID.");
      setIsMessageModalVisibleAssigned(true);
      setLoading(false);
      return;
    }

    try {
      const ctrequestAssignedPayload = {
        type: [{ target_id: "ct_scan_request" }],
        field_assigned_radiologist: [{ target_id: ctscanAssignedRadioLogist }],
        field_ct_scan_request_status: [{ value: ctscanrequestStatus }],
      };

      const response = await fetch(`/node/${data?.nid}?_format=json`, {
        method: "PATCH",
        credentials: "same-origin",
        mode: "same-origin",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Basic ${btoa(`${username}:${userpw}`)}`,
          "X-CSRF-Token": usercsrf_token,
        },
        body: JSON.stringify(ctrequestAssignedPayload),
      });

      if (!response.ok) {
        const error = await response.json();
        console.log(`Error: ${error.message}`);
        setModalMessages(`Error: ${error.message}`);
        setIsMessageModalIsNotOk(true);
        setLoading(false);

        return;
      }

      setctscanAssignedRadioLogist("");
      setctscanrequestStatus("");
      setIsMessageModalVisibleAssigned(true);
      await Promise.all([
        mutate(`${process.env.REACT_APP_CT_SCAN_REQUEST_URL}`),
        mutate(`${process.env.REACT_APP_CT_SCAN_REPORT_URL}`),
        mutate(`${process.env.REACT_APP_CT_SCAN_ASSIGNED_REQUEST_URL}`),
      ]);
    } catch (error) {
      setIsMessageModalVisibleAssigned(false);
    } finally {
      setLoading(false);
    }
  };

  if (ctrequestsDataError || ctscanAssignedRadioError || investigationsError) {
    return (
      <LoaderAnimation
        loadingTxt={`Check your network / internet connection and try again!, ${ctrequestsDataError}`}
      />
    );
  }

  if (
    ctrequestsDataLoading ||
    ctscanAssignedRadioLoading ||
    investigationsLoading
  ) {
    return <LoaderAnimation loadingTxt="Loading..." />;
  }

  return (
    <div className="dashboard-container">
      <DashboardContentHeader />

      <div className="content-wrapper">
        <DashboardContenLeftMenus />
        <div className="patient-register">
          <TopActionMenus AddTitle="CT Scan Assign register" />
          <SearchFilter
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            statusFilter={statusFilter}
            setStatusFilter={setStatusFilter}
            requestStartDate={requestStartDate}
            setRequestStartDate={setRequestStartDate}
            requestEndDate={requestEndDate}
            setRequestEndDate={setRequestEndDate}
            reportedStartDate={reportedStartDate}
            setReportedStartDate={setReportedStartDate}
            reportedEndDate={reportedEndDate}
            setReportedEndDate={setReportedEndDate}
          />
          {filteredData?.length > 0 ? (
            <table>
              <thead>
                <tr>
                  <td>Patient ID</td>
                  <td>Patient Full Name</td>
                  <td>Investigation</td>
                  <td>Investigation Cost</td>
                  <td>Radiologist</td>
                  <td>Request Date</td>
                  <td>Report Date</td>
                  <td>Request Status</td>
                  {/* <td>Request Fee</td> */}
                  <td>Action</td>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((ctrequests) => (
                  <tr key={ctrequests.nid}>
                    <td>{ctrequests.field_patient_id}</td>
                    <td>
                      {ctrequests.title === "Patient yet to be attached" ? (
                        <span className="tableyettobeadded">
                          Patient yet to be attached
                        </span>
                      ) : (
                        ctrequests.title
                      )}
                    </td>
                    <td>{ctrequests.title_1}</td>
                    <td>{ctrequests.field_investigation_price}</td>
                    <td> {ctrequests.field_assigned_radiologist}</td>
                    <td>{ctrequests.created}</td>
                    <td>{ctrequests.created_2}</td>
                    <td>{ctrequests.field_ct_scan_request_status}</td>
                    {/* <td>{ctrequests.field_payment_amount}</td> */}
                    <td className="formActionBtn">
                      <button
                        className="btn-modal"
                        onClick={() => {
                          toggleModalAssignRequest();
                          stateNavigator.refresh({
                            nid: ctrequests.nid,
                            ct_scan_investigation: ctrequests.title_1,
                            ct_scan_investigation_raw: ctrequests.nid_2,
                            ct_scan_request_status:
                              ctrequests.field_ct_scan_request_status,
                            ct_scan_request_status_NID:
                              ctrequests.field_ct_scan_request_status_1,
                            ct_scan_clinical_diagnosis:
                              ctrequests.field_ct_scan_clinical_diagnosis,
                            ct_scan_comments: ctrequests.field_ct_scan_comments,
                            ct_scan_patient_reference: ctrequests.title,
                            ct_scan_patient_reference_1:
                              ctrequests.field_ct_scan_patient_reference_1 ||
                              "0",
                            ct_scan_assigned_radiologist:
                              ctrequests.field_assigned_radiologist,
                            ct_scan_assigned_radiologistNID:
                              ctrequests.field_assigned_radiologist_1,
                          });
                        }}
                      >
                        Assign
                      </button>

                      <button
                        onClick={() =>
                          stateNavigator.navigate("viewctscanreportregister", {
                            nid: ctrequests.nid,
                          })
                        }
                      >
                        View report
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <LoaderAnimation loadingTxt="Loading report register" />
          )}

          {filteredData?.length > 0 && (
            <TableTotalNCost
              noOfReportLable="Number of request :"
              noOfReportLength={filteredData?.length}
              totalFeeCostLable="Total Fee Cost :"
              totalFeeCostValue={filteredData.reduce((total, report) => {
                const amount = Number(report?.field_payment_amount) || 0;
                return total + amount;
              }, 0)}
            />
          )}
          {modalEditRequest && (
            <div className="modal">
              <div className="overlay"></div>
              <div className="modal-content">
                <div className="modal-body">
                  <div className="modal-header">
                    <p>{`Updating ${data?.ct_scan_patient_reference} request`}</p>
                    <button
                      className="close-modal"
                      onClick={toggleModalEditRequest}
                    >
                      <FontAwesomeIcon icon={faClose} />
                    </button>
                  </div>

                  <form
                    onSubmit={handleSubmitEdit}
                    className="edit-patient-form"
                  >
                    <div className="form-group">
                      <label htmlFor="field_investigation">Investigation</label>
                      <select
                        value={ctscanIvestigation}
                        onChange={(e) => {
                          setctscanIvestigation(e?.target?.value);
                        }}
                        required
                      >
                        <option value="_none">
                          {investigationsLoading
                            ? "Loading Investigations..."
                            : "Select Investigation"}
                        </option>
                        {investigationsData?.map((item) => (
                          <option key={item.nid} value={item.nid}>
                            {item.title}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="form-group">
                      <label htmlFor="field_cliniccal-diag">
                        Clinical Diagnostic
                      </label>
                      <textarea
                        type="textarea"
                        placeholder="Enter Clinical Diagnostics"
                        value={ctscanClinicalDiag}
                        onChange={(e) => setctscanClinicalDiag(e.target.value)}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="field_comments">Comments</label>
                      <textarea
                        type="textarea"
                        placeholder="Enter Comments"
                        value={ctscanComments}
                        onChange={(e) => setctscanComments(e.target.value)}
                        required
                      />
                    </div>
                    <div className="submitGroup">
                      <button type="submit" disabled={loading}>
                        {loading ? (
                          <FontAwesomeIcon
                            icon={faSpinner}
                            spin={true}
                            strokeWidth={20}
                            fontSize={22}
                          />
                        ) : (
                          "Submit"
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}

          {modalAssignRequest && (
            <div className="modal">
              <div className="overlay"></div>
              <div className="modal-content">
                <div className="modal-body">
                  <div className="modal-header">
                    <p>{`Updating ${data?.ct_scan_patient_reference} request`}</p>
                    <button
                      className="close-modal"
                      onClick={toggleModalAssignRequest}
                    >
                      <FontAwesomeIcon icon={faClose} />
                    </button>
                  </div>

                  <form
                    onSubmit={handleSubmitAssigned}
                    className="edit-patient-form"
                  >
                    <div className="form-group">
                      <label htmlFor="assign-radiologist">
                        Assigned Radiologist
                      </label>
                      <select
                        value={ctscanAssignedRadioLogist}
                        onChange={(e) => {
                          setctscanAssignedRadioLogist(e.target.value);
                        }}
                        required
                      >
                        <option value="">Select Radiologist</option>
                        {ctscanAssignedRadioData?.map((ctscanradiologist) => (
                          <option
                            key={ctscanradiologist?.uid}
                            value={ctscanradiologist?.uid}
                          >
                            {ctscanradiologist.field_doctor_referer_full_name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="form-group">
                      <label htmlFor="field_request-status">Status</label>
                      <select
                        value={ctscanrequestStatus}
                        onChange={(e) => setctscanrequestStatus(e.target.value)}
                        required
                      >
                        <option key="none">Select Status</option>
                        <option key="pending" value={"pending"}>
                          Pending
                        </option>
                        <option key="assigned" value={"assigned"}>
                          Assigned
                        </option>
                        <option key="completed" value={"completed"}>
                          Completed
                        </option>
                        <option key="cancelled" value={"cancelled"}>
                          Cancelled
                        </option>
                      </select>
                    </div>
                    <div className="submitGroup">
                      <button
                        type="submit"
                        disabled={
                          !perm.includes("allow_editing_completed_request")
                        }
                      >
                        {loading ? (
                          <FontAwesomeIcon
                            icon={faSpinner}
                            spin={true}
                            strokeWidth={20}
                            fontSize={22}
                          />
                        ) : (
                          "Submit"
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}

          {isMessageModalVisibleEdit && (
            <MessageModal
              leftIcon={faCheckCircle}
              color="green"
              fontSize={20}
              message="Request updated successfully!"
              onClose={() =>
                setIsMessageModalVisibleEdit(false, toggleModalEditRequest())
              }
              rightIcon={faClose}
            />
          )}

          {isMessageModalVisibleAssigned && (
            <MessageModal
              leftIcon={faCheckCircle}
              color="green"
              fontSize={20}
              message="Request Assigned successfully!"
              onClose={() =>
                setIsMessageModalVisibleAssigned(
                  false,
                  toggleModalAssignRequest()
                )
              }
              rightIcon={faClose}
            />
          )}
          {isMessageModalError && (
            <MessageModal
              leftIcon={faWifi}
              color="red"
              fontSize={20}
              message="Error, check your internet connection and try again!"
              onClose={() => {
                toggleModalError();
              }}
              rightIcon={faClose}
            />
          )}
          {isMessageModalIsNotOk && (
            <MessageModal
              leftIcon={faCancel}
              color="red"
              fontSize={20}
              message={modalMessages}
              onClose={() => {
                toggleModalIsNotOk();
              }}
              rightIcon={faClose}
            />
          )}
        </div>
      </div>

      <DashboardContentFooter />
    </div>
  );
};

export default CtScanRequestAssignedRegister;
